/** Official SquareDeal forms site. Use this for every user-facing SquareDeal name. */
export const SQUAREDEAL_DOCS_URL = 'https://squaredealdocs.com';
